import { ISectionLogger } from "@multiweb/logging";
import { IRightsContext } from "Global/Base/Rights/IRightsContext";
import { IMultiEditObject } from "UI/UI.Controls/DataSource/MultiEdit/MEOWObject";
import { MultiObjectRightsEvaluator } from "./MultiObjectRightsEvaluator";
import { SingleObjectRightsEvaluator } from "./SingleObjectRightsEvaluator";
import { IRightsEvaluator, IRightsEvaluatorFactory } from "./types";

export class RightsEvaluatorFactory implements IRightsEvaluatorFactory {
    private _logger: ISectionLogger;

    constructor(logger: ISectionLogger) {
        this._logger = logger;
    }

    public getContextEvaluator(context: IRightsContext): IRightsEvaluator {
        if (context instanceof IMultiEditObject)
            return new MultiObjectRightsEvaluator(this._logger, context);
        else
            return new SingleObjectRightsEvaluator(this._logger, context);
    }
}
